import {SCREEN_NAMES} from '@/lib/analytics/analyticsConstants';
import {ViewType} from '@/types/models/search-creators/searchCreatorsStore';

function getAnalyticsSearchScreenName(viewType: ViewType) {
  return SCREEN_NAMES.SEARCH_CREATORS[viewType];
}

export default getAnalyticsSearchScreenName;
